import React from 'react';
import _ from 'lodash';

import { useItemReceiptWidgetQuery } from 'generated/graphql';
import Big from 'big.js';



export interface IReceivedItem {
  id: string;
  sku: string;
  inventoryNumber: string;
  refundAmountCents: Big;
}

export interface IData {
  lineItems: IReceivedItem[];
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useItemReceiptWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        lineItems: _.map(tuple.data?.returnAuthorization?.itemReceipt?.lineItems, (lineItem): IReceivedItem => ({
          id: lineItem.id,
          sku: lineItem.product.sku,
          inventoryNumber: lineItem.inventoryNumber,
          refundAmountCents: new Big(lineItem.refundAmountCents)
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
